import * as angular from "angular";
import * as _ from "lodash";
import {TaskType} from "../types/task.type";

angular
  .module('bringoz.admin.tasks')
  .filter('taskCourierPrice', taskCourierPrice);

/* @ngInject */
function taskCourierPrice($filter, splitService) {
  return function (task, defaultValue) {

    if (_.isUndefined(task)) {
      return defaultValue || '';
    }

    const price = task.taskType === TaskType.BundledStopover ? _.sumBy(task.bundledTaskList, (bt: any) => {
      return _.get(bt, 'serviceInfo.courierPrice', 0);
    }) : _.get(task, 'serviceInfo.courierPrice', 0);

    const currency = splitService.getCurrencyCode();
    return $filter('isoCurrency')(price, currency);
  }
}
